import { render, staticRenderFns } from "./maintainanceTaskDetailsList.vue?vue&type=template&id=2cc0128f&scoped=true"
import script from "./maintainanceTaskDetailsList.vue?vue&type=script&lang=js"
export * from "./maintainanceTaskDetailsList.vue?vue&type=script&lang=js"
import style0 from "./maintainanceTaskDetailsList.vue?vue&type=style&index=0&id=2cc0128f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc0128f",
  null
  
)

export default component.exports